import {defaults}     from "../../commun/backbone/decorators";
import Routing        from "../app/router";
import LoginBaseModel from "./login-base-model";

@defaults({
                with_configuration: false,
          })
class LoginModel extends LoginBaseModel
{
    fCanUserConfigure(login)
    {
        return new Promise((resolve, reject) => {
            $.ajax({
                   url  : Routing.generate('session_with_configuration'),
                   data : { login }
               }).then(resolve, reject);
        });
    }

    resetPassword(login)
    {
        return new Promise((resolve, reject) => {
            $.ajax({
                   url  : Routing.generate('session_reset_password_intranet'),
                   data : { login }
               }).then(resolve, reject);
        });
    }

    executeAction(idaction)
    {
        return new Promise((resolve, reject) => {
            $.ajax({
                       url  : Routing.generate('session_execute_action', { idaction }),
                   }).then(resolve, reject);
        });
    }
}
export default LoginModel;